import { render } from "./SidebarLogo.vue?vue&type=template&id=266f5342&scoped=true&ts=true"
import script from "./SidebarLogo.vue?vue&type=script&lang=ts"
export * from "./SidebarLogo.vue?vue&type=script&lang=ts"

import "./SidebarLogo.vue?vue&type=style&index=0&id=266f5342&lang=scss&scoped=true"

import exportComponent from "D:\\code\\GWSD\\ttnewadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-266f5342"]])

export default __exports__